import * as React from "react";

const SvgFilter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 938.8 700"
    style={{
      enableBackground: "new 0 0 938.8 700",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M865 166.9H73.8c-33.1 0-60-26.9-60-60s26.9-60 60-60H865c33.1 0 60 26.9 60 60s-26.8 60-60 60zm-65.8 182.8c0-33.1-26.9-60-60-60H199.6c-33.1 0-60 26.9-60 60s26.9 60 60 60h539.6c33.1 0 60-26.8 60-60zm-180 242.9c0-33.1-26.9-60-60-60H379.6c-33.1 0-60 26.9-60 60s26.9 60 60 60h179.6c33.1 0 60-26.9 60-60z" />
  </svg>
);

export default SvgFilter;
